module.exports = __webpack_public_path__ + "img/img-cardnews-01-1.1b2902a9.png";